import ApiServiceWrapper from './../../api-request.service';
import { MswApiStatusResponse } from '@/shared/types/api-common-types';

const usageReport = 'getmsspusageReport';
const usageReportApi = {
  postUsageReportData(data: any) {
    const reqEndPoint = `mssp/${usageReport}`;
    return ApiServiceWrapper.post<MswApiStatusResponse>(`${reqEndPoint}`, data);
  },
  // postUsageReportDataNew(data: any) {
  //   const reqEndPoint = 'mssp/getmsspusageReport-new';
  //   return ApiServiceWrapper.post<MswApiStatusResponse>(`${reqEndPoint}`, data);
  // },
  getMsspList() {
    const reqEndPoint = 'mssp/get-mssp-prefilter';
    return ApiServiceWrapper.get<MswApiStatusResponse>(`${reqEndPoint}`);
  },
  getMsspListWithSource() {
    const reqEndPoint = 'mssp/get-mssp-prefilter?varsource=LICENSEREPORT';
    return ApiServiceWrapper.get<MswApiStatusResponse>(`${reqEndPoint}`);
  },
  postFilterPreference(data: any) {
    const reqEndPoint = 'mssp/savemsspuserpreference';
    const reqBody = {
      preferenceData: data,
      preferenceSource: 'MSSPREPORT',
    };
    return ApiServiceWrapper.post<MswApiStatusResponse>(`${reqEndPoint}`, reqBody);
  },
  getMsspPreferenceFilter() {
    const reqEndPoint = 'mssp/getmsspuserpreference?source=MSSPREPORT';
    return ApiServiceWrapper.get<MswApiStatusResponse>(`${reqEndPoint}`);
  },
};

export default usageReportApi;
